import { render } from "./PiclistCards.vue?vue&type=template&id=b07adfb2&scoped=true"
import script from "./PiclistCards.vue?vue&type=script&lang=js"
export * from "./PiclistCards.vue?vue&type=script&lang=js"

import "./PiclistCards.vue?vue&type=style&index=0&id=b07adfb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07adfb2"]])

export default __exports__